export default "__VITE_ASSET__BdfO$pNJ__"